import React from 'react'
import { Link } from 'react-router-dom'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import style from '../../style'

import Container from '../../partials/Container'
import UserEditor from '../../partials/UserEditor'

import access from '../../../../utils/access'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Community', 'Auth', 'User', 'Config')
@observer
export class CommunityUser extends React.Component {
  componentWillMount () {
    const comId = this.props.match.params.comId
    const userId = this.props.match.params.userId

    const userUser = this.props.User.all.slice().find(u => u.id === userId)
    const userComm = (this.props.Community.users[comId] || [])
      .slice()
      .find(u => u.id === userId)

    const _findCommunity = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending) {
          return _findCommunity()
        }

        Promise.all([
          ...(!this.props.Community.all.slice().find(c => c.id === comId)
            ? [this.props.Community.getCommunity(comId)]
            : []),
          ...(!userUser || !userComm
            ? [this.props.User.searchUsers(userId)]
            : [])
        ]).catch(() => this.props.history.push(`/dashboard/community`))
      }, 500)
    }

    _findCommunity()
  }

  onGroupClick (e) {
    const comId = this.props.match.params.comId
    const userId = this.props.match.params.userId

    const gId = e.currentTarget.dataset.gid
    const groups = this.props.Community.groups[comId]
      .slice()
      .filter(g => g.users.includes(userId))

    const groupsObj = groups.reduce((obj, g) => ({ ...obj, [g.id]: true }), {})
    return this.props.Community.patchCommunityUserGroup(
      comId,
      userId,
      'group',
      {
        ...groupsObj,
        [gId]: !groupsObj[gId]
      }
    )
  }

  onSaveClick (e) {
    const url = Object.keys(this.props.match.params).reduce(
      (_url, key) =>
        key !== 'userId'
          ? _url.replace(`:${key}`, this.props.match.params[key])
          : _url,
      this.props.match.path.replace(`/:userId`, ``)
    )

    return this.props.history.push(url)
  }

  render () {
    const comId = this.props.match.params.comId
    const userId = this.props.match.params.userId
    const groups = (this.props.Community.groups[comId] || []).slice()

    const userUser = this.props.User.all.slice().find(u => u.id === userId)
    const userComm = (this.props.Community.users[comId] || [])
      .slice()
      .find(u => u.id === userId)
    const community = this.props.Community.all.slice().find(c => c.id === comId)

    return (
      <Container {...this.props}>
        <Row>
          <Col xs='12' lg='6'>
            <h2 className={css(style.headers.h2)}>Edit Member</h2>
          </Col>
          <Col>
            <Row>
              {access.adminCom(this.props.User.me.permissions || {}) ? (
                <Col>
                  <Link
                    to={`/dashboard/user/${userId}`}
                    className={css(style.buttons.button, style.buttons.red)}
                  >
                    View Profile
                  </Link>
                </Col>
              ) : (
                <Col />
              )}
              <Col>
                <span
                  onClick={this.onSaveClick.bind(this)}
                  className={css(style.buttons.button, style.buttons.red)}
                >
                  Go Back
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <UserEditor
            theme={THEME_LIST[this.props.Config.theme]}
            {...userUser || userComm}
            community={{ ...community, groups: groups || [] }}
            onGroupClick={this.onGroupClick.bind(this)}
          />
        </Row>
      </Container>
    )
  }
}

export default CommunityUser



// WEBPACK FOOTER //
// ./src/components/Community/User/Edit/index.js